import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardsSectionComponent} from "@app/_modules/pages/sections/types/basic/cards/cards-section.component";
import {CardsSectionItemsComponent} from "@app/_modules/pages/sections/types/basic/cards/items/cards-section-items.component";
import {CardsSectionItemComponent} from "@app/_modules/pages/sections/types/basic/cards/items/item/cards-section-item.component";
import {CardsItemPersonsComponent} from "@app/_modules/pages/sections/types/basic/cards/items/item/types/persons/cards-item-persons.component";
import {CardsItemPartnersComponent} from "@app/_modules/pages/sections/types/basic/cards/items/item/types/partners/cards-item-partners.component";
import {SortablejsModule} from "@dustfoundation/ngx-sortablejs";
import {SwiperModule} from "swiper/angular";
import { WidjetModule } from '@app/_modules/widjet/widjet.module';
import { CardsItemDefaultComponent } from './items/item/types/default/cards-item-default.component';
import { CardsItemSlidesComponent } from './items/item/types/slides/cards-item-slides.component';
import { CardsItemNewsComponent } from './items/item/types/news/cards-item-news.component';
import { CardsItemListComponent } from './items/item/types/list/cards-item-list.component';
import { CardsSectionAdsComponent } from './items/item/types/ads/cards-item-ads.component';
import { CardsItemColumnsComponent } from './items/item/types/columns/cards-item-columns.component';

@NgModule({
  imports: [
    CommonModule,
    SortablejsModule,
    WidjetModule,
    SwiperModule
  ],
  declarations: [
    CardsSectionComponent,
    CardsSectionItemsComponent,
    CardsSectionItemComponent,
    CardsItemPersonsComponent,
    CardsItemPartnersComponent,
    CardsItemDefaultComponent,
    CardsItemSlidesComponent,
    CardsItemNewsComponent,
    CardsItemListComponent,
    CardsItemColumnsComponent,
    CardsSectionAdsComponent
  ],
  exports: [
    CardsSectionComponent
  ]
})
export class CardsSectionModule {
}
